import React, { useEffect, useState } from 'react'
import $ from 'jquery';
import Styles from '../../assets/stylesheets/layout.module.css'
import { useDispatch, useSelector } from 'react-redux'
import { DEFAULT_DATA_TABLE_ORDER, FORBIDDEN_STATUS_CODE, REPORT_PAGINATION } from '../../actions/constants';
import { getExamsList } from '../../actions/examsActions'
import { getTests } from '../../actions/testsActions';
import { generateReviewProgressReportByExam, getReviewProgressReportByExam, GET_REVIEW_PROGRESS_REPORT_BY_EXAM } from '../../actions/reportsActions';
import Select from 'react-select';
import ReportList from './ReportList';
import swal from 'sweetalert2';
import moment from 'moment/moment';
import XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import IconTooltip from '../utils/IconTooltip';
import Switch from 'react-switch';

export default function ReviewProgressReportByExam(props) {

  const dispatch = useDispatch()
  const exams = useSelector(state => state.exams.examList)
  const tests = useSelector(state => state.tests.tests)
  const report = useSelector(state => state.reports.reviewProgressReportByExam)
  const pagination = useSelector(state => state.reports.reviewProgressReportByExamPagination)

  const [options, setOptions] = useState({
    exams: [],
    tests: []
  })
  const [ form, setForm ] = useState({
    exams: [],
    tests: []
  })
  const [ groupMode, setGroupMode ] = useState('aggregated')

  const clearReportState = () => {
    if ($.fn.dataTable.isDataTable('#tblReviewProgressReportByExam')){
      $('#tblReviewProgressReportByExam').DataTable().destroy()
    }
    dispatch({
      type: GET_REVIEW_PROGRESS_REPORT_BY_EXAM,
      payload: { reportList: [], links: {} }
    })
  }

  const handleExamsChange = (selected) => {
    clearReportState()
    setGroupMode('aggregated')
    setForm({
      exams: selected || [],
      tests: []
    })
  }

  const initReportTable = () => {
    if ($.fn.dataTable.isDataTable('#tblReviewProgressReportByExam')){
      $('#tblReviewProgressReportByExam').DataTable().destroy()
    }
    if ($('#tblReviewProgressReportByExam').length) {
      $('#tblReviewProgressReportByExam').DataTable(DEFAULT_DATA_TABLE_ORDER)
    }
  }

  const handleTestsChange = (selected) => {
    setForm({
      ...form,
      tests: selected || []
    })
  }

  const sortedExamIds = () => form.exams.map(exam => exam.value).sort((a, b) => a - b)
  const sortedTestIds = () => form.tests.map(test => test.value).sort((a, b) => a - b)

  const generateReport = (event) => {
    event.preventDefault();
    swal({
      title: '¿Está seguro?',
      text: 'Se generará un nuevo reporte a la fecha',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.value) {
        const successCallback = () => {
          swal({
            type: 'success',
            title: 'El reporte se está generando',
            showConfirmButton: false,
            timer: 1200
          });
        };

        const errorCallback = (error) => {
          console.log('Error overwriting the grade', error.request);
          if (error.request.status === FORBIDDEN_STATUS_CODE) {
            swal(
              'Ups...',
              `Ocurrió un error al tratar de generar el reporte`,
              'error'
            );
          } else {
            swal(
              'Ups...',
              'Ocurrió un error al tratar de generar el reporte',
              'error'
            );
          }
        };
        const data = {
          exam: sortedExamIds(),
          test_id: sortedTestIds()
        }
        dispatch(generateReviewProgressReportByExam(data, successCallback, errorCallback))
      }
    });
    
   
  }

  const reloadReport = () => {
    
    if ($.fn.dataTable.isDataTable('#tblReviewProgressReportByExam')){
      $('#tblReviewProgressReportByExam').DataTable().destroy()
    }

    const successCallback = () => {
      swal({
        type: 'success',
        showConfirmButton: false,
        timer: 1000
      });
     
      $('#tblReviewProgressReportByExam').DataTable(DEFAULT_DATA_TABLE_ORDER)
    }

    const errorCallback = (error) => {
      console.log('Error creating the exam', error.request);
    }
    dispatch(getReviewProgressReportByExam(sortedExamIds(), sortedTestIds(), REPORT_PAGINATION, successCallback, errorCallback))
  }

  const onPaginateReport = (paginate) => {
    
    if ($.fn.dataTable.isDataTable('#tblReviewProgressReportByExam')){
      $('#tblReviewProgressReportByExam').DataTable().destroy()
    }

    const successCallback = () => {
      swal({
        type: 'success',
        showConfirmButton: false,
        timer: 1000
      });
     
      $('#tblReviewProgressReportByExam').DataTable(DEFAULT_DATA_TABLE_ORDER)
    }

    const errorCallback = (error) => {
      console.log('Error creating the exam', error.request);
    }
    dispatch(getReviewProgressReportByExam(sortedExamIds(), sortedTestIds(), paginate, successCallback, errorCallback))
  }

  const downloadXls = (elementId, filename) => {
    const table_div = document.getElementById(elementId);

    const reporte = XLSX.utils.table_to_book(table_div, {sheet:"Reporte"});
    const archivo_reporte = XLSX.write(reporte, {bookType:'xlsx', bookSST:true, type: 'binary'});
    var buffer = new ArrayBuffer(archivo_reporte.length);
    var view = new Uint8Array(buffer);
    for (var i=0; i<archivo_reporte.length; i++) view[i] = archivo_reporte.charCodeAt(i) & 0xFF;

    saveAs(new Blob([buffer],{type:"application/octet-stream"}), filename);
  }

  const renderReviewProgressReport = () => {
    const data = report.reportList[0]?.reportInfo
    const byTest = groupMode === 'by_test'
    const tableRows = byTest ? (data?.reportDataByTest || []) : (data?.reportData || [])
    const hasBreakdown = (data?.reportDataByTest?.length ?? 0) > 0
    
    if (report && data) {
      return (
        <div  className="table-responsive  col-xs-12">
            {tableRows.length > 0?
                <>
                {hasBreakdown && (
                  <div style={{ marginBottom: '12px' }}>
                    <span>
                      Agrupados
                      <Switch
                        uncheckedIcon={false}
                        checkedIcon={false}
                        onColor="#86d3ff"
                        checked={byTest}
                        onChange={(checked) => setGroupMode(checked ? 'by_test' : 'aggregated')}
                      />
                      Desagrupados
                    </span>
                  </div>
                )}
                <ul className="list-group scrolling-list">
                  <table id="tblReviewProgressReportByExam" className="table table-bordered dt-responsive table-striped">
                    <thead>
                      <tr>
                        <th style={{ display: 'none' }}>Examen</th>
                        <th style={{ display: byTest ? undefined : 'none' }}>Pregunta</th>
                        <th>Revisor</th>
                        <th>En espera</th>
                        <th>En espera por devolución</th>
                        <th>En revisión</th>
                        <th>Terminada</th>
                        <th>Codificada por revisor</th>
                        <th>Corregidos no discrepantes</th>
                        <th>Saltados</th>
                        <th>Total asignadas</th>
                      </tr>
                    </thead>
                    <tbody>
                    {tableRows.map((row, index) => {
                      return (
                          <tr key={index}>
                            <td style={{ display: 'none' }}>{row.examTitle}</td>
                            <td style={{ display: byTest ? undefined : 'none' }}>{row.testTitle}</td>
                            <td>{row.reviewerEmail}</td>
                            <td>{row.onHold || 0}</td>
                            <td>{row.onHoldReject || 0}</td>
                            <td>{row.toDo || 0}</td>
                            <td>{row.done || 0}</td>
                            <td>{row.doneR || 0}</td>
                            <td>{row.skipReject || 0}</td>
                            <td>{row.skip || 0}</td>
                            <td>{row.totalAssigned || 0}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                  <p><strong>Total de registros: </strong>{byTest ? (data.totalRecordsByTest ?? tableRows.length) : data.totalRecords}</p>
                </ul>
                <div className="row">
                    <div className="col-md-12 col-xs-12">
                      <button
                        onClick={() => {
                          let fecha = new Date();
                          fecha = moment(fecha).format('D [de] MMMM [de] YYYY');
                          downloadXls("tblReviewProgressReportByExam",
                          `reporte_progreso_revisiones_por_examen_${fecha}.xlsx`)
                        }}
                        type="button"
                        className="btn btn-default pull-right"
                      ><IconTooltip text="Descargar" icon="fa-download"/>
                      </button>
                    </div>
                </div>
                </>
            :
            <div className="row text-center">
                <h5>No hay datos disponibles</h5>
            </div>}
        </div>
      );
 
    }
  }
  
  
  useEffect(()=>{
    if (tests) {
      const testsById = new Map()
      Object.values(tests).forEach(({ id, title }) => {
        if (!testsById.has(id)) {
          testsById.set(id, { value: id, label: title })
        }
      })
      setOptions({
        ...options,
        tests: Array.from(testsById.values())
      })
    }
  },[tests])

  useEffect(()=>{
    const examIds = sortedExamIds()
    if (examIds.length > 0) {
      dispatch(getTests(`?exam=${examIds.join(',')}`))
    }
  },[form.exams])

  useEffect(() => {
    const info = report?.reportList?.[0]?.reportInfo
    if (!info) return
    const hasRows = (info.reportData?.length ?? 0) > 0 || (info.reportDataByTest?.length ?? 0) > 0
    if (hasRows) initReportTable()
  }, [groupMode, report])

  useEffect(()=>{
    
    if (exams) {
     
      const examsSorted = Object.values(exams).sort((a, b) => b.id - a.id) 
      setOptions({
        ...options,
        exams: examsSorted.map(({id:value, title:label })=>({ value, label }))
      })
    }
  },[exams])

  useEffect(()=>{
    dispatch(getExamsList())
    // Limpiar el estado del reporte al montar el componente
    dispatch({
      type: GET_REVIEW_PROGRESS_REPORT_BY_EXAM,
      payload: { reportList: [], links: {} }
    })
    // Limpiar la DataTable si existe
    if ($.fn.dataTable.isDataTable('#tblReviewProgressReportByExam')){
      $('#tblReviewProgressReportByExam').DataTable().destroy()
    }
    // Limpiar el formulario
    setForm({
      exams: [],
      tests: []
    })
    
    return () => {
      if ($.fn.dataTable.isDataTable('#tblReviewProgressReportByExam')){
        $('#tblReviewProgressReportByExam').DataTable().destroy()
      }
    }
  },[])

  return (
    <div className={Styles.main}>
      <section>
        <div className='row'>
          <h1>Reporte de progreso de revisiones</h1>
          <p> A continuación, podrá generar un reporte de progreso de revisiones para uno o más exámenes. Para ello, seleccione uno o más exámenes y las preguntas que desea incluir en el reporte. Si elige varios exámenes, los totales se agrupan en una fila por revisor.
          </p>
          <form id='generateReport' >
            <div className='col-sm-6'>
              <label htmlFor="examSelect">Exámenes</label>
              <Select
                onChange={handleExamsChange}
                value={form.exams}
                placeholder="Seleccione uno o más exámenes"
                multi={true}
                options={options.exams} 
                required={true}
                inputId="examSelect"
                id="examSelect"
                name="examSelect"
              />

            </div>
            {form.exams.length > 0  && (
              <div className='col-sm-6'>
              <label htmlFor="testSelect">Preguntas</label>
              <Select
                onChange={handleTestsChange}
                value={form.tests}
                placeholder="Seleccione las preguntas"
                multi={true}
                options={options.tests} 
                required={true}
                inputId="testSelect"
                id="testSelect"
                name="testSelect"
              />
              </div>

            )}
            </form>
          </div>
          {(form.exams.length > 0 && form.tests.length > 0) && (
            <ReportList reports={report ? report: {reportList: []}}
              reportType= 'estados de revisiones'
              pagination = {pagination}
              onReloadReport = {reloadReport}
              onPaginateReport={onPaginateReport}
              onGenerateReportSubmit ={generateReport}
              onChangeDefaultReport ={reloadReport}
              description="En este reporte puede ver los estados de las revisiones por examen">
            </ReportList>
          ) }
          { report && report.reportList.length!==0 && 
            renderReviewProgressReport()
          }
      </section>
      <section 
				style={{
					display: 'flex',
					alignItems: 'center',
					flexFlow: 'row nowrap',
					justifyContent: 'space-between',
				}}
			>
				<button
					onClick={() => props.history.push(`/`)}
					type="button"
					className="btn btn-danger">
					Volver
				</button>
			</section>

    </div>
  )
}
